import React, { useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";

export default function ReviewsPage() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAprobadas();
  }, []);

  // 🌍 OBTENER RESEÑAS APROBADAS DESDE TU BACKEND
  const fetchAprobadas = async () => {
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/reviews`);
      const data = await res.json();

      if (!res.ok) {
        console.error("❌ Error al cargar reseñas:", data.error);
      } else {
        setReviews(data);
      }
    } catch (err) {
      console.error("💥 Error de red:", err);
    }

    setLoading(false);
  };

  if (loading) return <p style={{ textAlign: "center" }}>Cargando reseñas...</p>;

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f9f9f9, #ffffff)",
        padding: "40px 20px",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "40px",
          color: "#333",
          fontSize: "28px",
          fontWeight: "700",
        }}
      >
        Opiniones de nuestros clientes 💬
      </h2>

      {reviews.length === 0 ? (
        <p style={{ textAlign: "center" }}>
          Aún no hay reseñas publicadas. ¡Sé el primero en opinar! 😊
        </p>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "20px",
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          {reviews.map((r) => (
            <div
              key={r.id}
              style={{
                background: "white",
                borderRadius: "15px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                padding: "20px",
              }}
            >
              <h3 style={{ marginBottom: "8px", color: "#333" }}>{r.nombre}</h3>
              <p style={{ color: "#555", marginBottom: "10px" }}>{r.email}</p>
              <div style={{ marginBottom: "10px" }}>
                {[...Array(r.rating)].map((_, i) => (
                  <FaStar key={i} color="#FFD700" />
                ))}
              </div>
              <p style={{ fontStyle: "italic", color: "#444" }}>
                “{r.comentario}”
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
